import { useEffect, useState } from "react";
import api from "../../services/api";
import Loading from "../../load/loading";
import {
  Card,
  Grid,
  MenuItem,
  TextField,
} from "@mui/material";
import HeaderSession from "../../utils/headerSession";
import RegisterAccess from "../../utils/registerAccess";
import { RelatorioAdministadoresPdf } from "../exports/gerarelatoriopdf";
import { RelatorioAdministadoresExcel } from "../exports/gerarelatorioexcel";
import FichaAdmin from "./fichaAdmin";
import Paginacao from "../../utils/paginacao";
import { useSearchParams } from "react-router-dom";

export default function ListaFuncionarios() {
  const [admins, setAdmins] = useState([]);
  const [status, setStatus] = useState("");
  const [funccao, setFunccao] = useState("");
  const [funcoes, setFuncoes] = useState([]);
  const [handleUpdate, setHandleUpdate] = useState('');
  const [configLista, setConfigLista] = useState('');
  const [searchParams] = useSearchParams();
  const [page, setPage] = useState(searchParams.get("page"));
  const [perPage, setPerPage] = useState(20);

  useEffect(() => {
    setAdmins([]);
    api
      .get(`/admins?status=${status}&funcao=${funccao}&perPage=${perPage}&page=${page}`)
      .then((response) => {
        setConfigLista(response.data);
        setAdmins(response.data.Admins);

        // Extrair funções únicas dos administradores
        const uniqueFuncoes = [
          ...new Set(response.data.Admins.map((admin) => admin.funcao)),
        ];
        setFuncoes(uniqueFuncoes);
      })
      .catch((err) => console.error("Erro ao buscar funcionários:", err));
  }, [status, funccao, handleUpdate, page, perPage]); // Sempre que status ou funccao mudar, a busca será feita automaticamente

  return (
    <>
      <RegisterAccess page={"lista de funcionarios"} />

      <HeaderSession
        title={"USUARIOS ADMINISTRADORES DO SISTEMA"}
        actions={true}
        handleExportExcel={() => RelatorioAdministadoresExcel(admins)}
        handleExportPDF={() => RelatorioAdministadoresPdf(admins)}
      />

      <div>
        {/* Filtros */}
        <Grid container spacing={2} style={{ marginBottom: '10px' }}>
          <Grid item xs={12} sm={6} md={2}>
            <TextField
              size="small"
              select
              fullWidth
              label="Status"
              value={status}
              onChange={(e) => setStatus(e.target.value)}
              variant="outlined"
            >
              <MenuItem value="">Todos</MenuItem>
              <MenuItem value="Activo">Ativo</MenuItem>
              <MenuItem value="Inactivo">Inativo</MenuItem>
            </TextField>
          </Grid>

          <Grid item xs={12} sm={6} md={2}>
            <TextField
              size="small"
              select
              fullWidth
              label="Função"
              value={funccao}
              onChange={(e) => setFunccao(e.target.value)} // Apenas atualiza o estado
              variant="outlined"
            >
              <MenuItem value="">Todas as Funções</MenuItem>
              {funcoes.map((funcao) => (
                <MenuItem key={funcao} value={funcao}>
                  {funcao}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
        </Grid>

        {admins.length > 0 ? (
          <Grid style={{ display: 'flex', flexWrap: 'wrap', gap: '10px', justifyContent: 'center' }}>
            {admins.map((admin) => (
              
                <FichaAdmin local={'perfilAdmin'} key={admin._id} admin={admin} setHandleUpdate={setHandleUpdate} list={true} />
            ))}

            <Card style={{ marginBottom: 10, width: '98%' }}>
              <Paginacao
                configLista={configLista}
                lista={admins}
                page={page}
                setPage={setPage}
                setPerPage={setPerPage}
              />
            </Card>
          </Grid>
        ) : (
          <Loading />
        )}
      </div>
    </>
  );
}
